import { HealthcarePlanData } from './types'

export const initialHealthcarePlanData: HealthcarePlanData = {
  providerName: undefined,
  planName: undefined,
  renewalDate: undefined,
  waitingPeriodMonths: undefined,
  allowPreExistingConditions: undefined,
  planDocument: undefined,
  employeeCostCents: undefined,
  coveredEmployeeCostCents: undefined,
  dependentCostCents: undefined,
  coveredDependentCostCents: 0,
  companyId: 0,
}
